import { useState } from 'react'
import { useCASNotificationsContext } from '../../../../../../CASNotificationsContext'
import {
  ByRoutingGroupsFormItemProps,
  ByRoutingGroupsFormItemValue,
} from './types'
import CIMSCollapse from 'components/CIMSCollapse'
import GroupFallback from '../../../../../../components/GroupFallback'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { LabeledValueType } from 'components/CIMSSelect/types'
import ApproverTags from '../../../../../../components/ApproverTags'
import { Space } from 'antd'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import { alphabeticalSort } from '@cims-online/shared'

const ByRoutingGroupsFormItem: React.FC<ByRoutingGroupsFormItemProps> = ({
  value,
  onChange,
}) => {
  const { event } = useCIMSNotificationsPanelContext()
  const { casRoutingGroups, approverEvents } = useCASNotificationsContext()
  const [values, setValues] = useState<
    Map<string, ByRoutingGroupsFormItemValue>
  >(
    (value ?? []).reduce(
      (map, v) => map.set(v.routingGroupId, v),
      new Map<string, ByRoutingGroupsFormItemValue>()
    )
  )

  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback />}
      panels={(casRoutingGroups ?? [])
        .sort(alphabeticalSort('name'))
        .map(({ id, name, description }) => ({
          key: id,
          header: {
            type: 'described',
            name,
            description,
          },
          children: (
            <Space size="large" direction="vertical" style={{ width: '100%' }}>
              {approverEvents.some(
                (approverEvent) => approverEvent.id === event.id
              ) && <ApproverTags routingGroup={{ id, name }} />}
              <CIMSFormItem label="Recipients">
                <RecipientsSelect
                  value={values.get(id.toString())?.recipients ?? []}
                  onChange={(value) => {
                    const recipients = value as LabeledValueType[]
                    setValues((prev) => {
                      const map = new Map(prev)
                      map.set(id.toString(), {
                        routingGroupId: id.toString(),
                        recipients,
                      })
                      onChange?.([...map.values()])
                      return map
                    })
                  }}
                />
              </CIMSFormItem>
            </Space>
          ),
        }))}
    />
  )
}

export default ByRoutingGroupsFormItem
